import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { observer } from 'mobx-react';
import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import { useUserStore } from '@roc/feature-app-core';
import { useLoanStore, usePayoffRequestStore } from '@roc/feature-loans';
import { Paper, PaperBorderType, ProgressBarComponent, SelectField } from '@roc/ui';
import { VirtualScroll } from './components/common/virtualScroll';
import PayoffsKeyInformationCollapse from './components/key-information-collapse/payoffsKeyInformationCollapse';
import PayoffLoanActors from './components/loan-actors/payoffLoanActors';
import { PayoffActionButtons } from './components/action-buttons/payoffActionButtons';
import { PayoffTodos } from 'libs/feature-loans/src/loans/loanDetails/payoffs/components/payoffTodos';
import { RequestPayoffButton } from 'libs/feature-loans/src/loans/loanDetails/payoffs/components/requestPayoffButton';
import { isNil, LoanProcess } from '@roc/feature-utils';
import { useDocumentStore } from '@roc/feature-documents';
import { TaskV2Type } from '@roc/feature-general-tasks';

const useStyles = makeStyles(() => ({
  gridContainer: {
    height: 'fit-content',
    padding: '10px',
  },
  gridHeader: {
    padding: 16,
  },
}));

export const PayoffsInternal = observer(() => {
  const classes = useStyles();
  const { documentStore } = useDocumentStore();
  const { loanStore } = useLoanStore();
  const loanProcess = LoanProcess.PAYOFF;
  const { userStore } = useUserStore();
  const { payoffRequestStore } = usePayoffRequestStore();
  const [specialistsDropdown, setSpecialistsDropdown] = useState();
  const [selectedPayoffId, setSelectedPayoffId] = useState<number>();
  const params = useParams<{ loanId: string }>();
  const loanId = params.loanId;

  useEffect(() => {
    payoffRequestStore.initPayoffInternal(loanId);
    async function fetchSpecialistsDropdown() {
      await loanStore.fetchSpecialistsDropdown();
      setSpecialistsDropdown(loanStore.specialistsDropdown);
    }
    fetchSpecialistsDropdown();
  }, [loanId]);

  useEffect(() => {
    setSelectedPayoffId(payoffRequestStore.selectedPayoffId);
  }, [payoffRequestStore.selectedPayoffId])

  useEffect(() => {
    if (payoffRequestStore.selectedPayoff) {
      documentStore.loanTodosStore.fetchTodos(+loanId, loanProcess, TaskV2Type.PAYOFF_ID, payoffRequestStore.selectedPayoffId);
    }
  }, [payoffRequestStore.selectedPayoff])

  const handleSelectePayoff = (payoffId: number) => {
    payoffRequestStore.getPayoffById(+loanId, payoffId)
  }


  const payoffOptions = payoffRequestStore?.loanPayoffs?.map(loanPayoff => {
    return {
      label: `Payoff ${loanPayoff?.payoffNumber}`,
      value: loanPayoff?.loanPayoffDataId,
    }
  }) ?? [];

  return (
    <VirtualScroll>
      <Grid container className={classes.gridContainer} spacing={2}>

        {payoffRequestStore?.selectedPayoff?.loanPayoffStages?.length > 0 && (<>
          <Grid item xs={11}>
            <ProgressBarComponent
              progressArray={
                payoffRequestStore?.selectedPayoff?.loanPayoffStages
              }
              active={payoffRequestStore?.selectedPayoff?.payoffStatus}
              allowNonExistingStep
            />
          </Grid>
          <Grid item xs={1}>
            <Grid container direction='row' justifyContent='flex-end'>
              <Grid item>
                <SelectField
                  label='Payoff #'
                  options={payoffOptions}
                  testId={'selectedPayoff'}
                  value={selectedPayoffId}
                  onChange={value => handleSelectePayoff(value)}
                  fullWidth
                  variant="outlined"
                  standaloneLabel
                />
              </Grid>
            </Grid>
          </Grid>
        </>
        )}
        <Grid item xs={12}>
          <PayoffsKeyInformationCollapse loan={loanStore.loanDetails} currentPayoff={payoffRequestStore?.selectedPayoff} />
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            spacing={2}
          >
            <Grid item xs={6}>
              <PayoffLoanActors loan={loanStore.loanDetails} specialistsDropdown={specialistsDropdown} />
            </Grid>
            <Grid item xs={6}>
              <PayoffActionButtons loanId={loanId} />
            </Grid>
            {!isNil(payoffRequestStore.selectedPayoffId) &&
              <Grid item xs={12}>
                <Paper borderType={PaperBorderType.SOLID_BORDER} titleComponent={
                  <Grid container direction='row' justifyContent='space-between' className={classes.gridHeader}>
                    <Grid item>
                      <Typography variant='h5' component='h5'>Payoff Documents & Tasks</Typography >
                    </Grid >
                  </Grid>
                }>
                  <Grid item xs={12}>
                    <Grid
                      container
                      direction="row"
                      spacing={2}
                      justifyContent='center'
                    >
                      <Grid item xs={12}>
                        <PayoffTodos isCPortal={!userStore.globalStore.isInternalPortal} loanId={+loanId} payoffId={payoffRequestStore.selectedPayoffId} />
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            }
          </Grid>
        </Grid>
      </Grid>
      <Box style={{ height: "80px" }}>
        {/* Placeholder to give space to conversations button*/}
      </Box>
    </VirtualScroll >
  );
});
